// components/SuccessPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const SuccessPage = ({ 
  title = "Report Submitted Successfully!",
  subtitle = "Your report has been successfully submitted.",
  downloadButtonText = "Download PDF Report",
  backButtonText = "Back to Form",
  onDownload,
  onBack,
  reportDetails = {},
  showContactInfo = true,
  contactInfo = {
    phone: "(785) 966-3060",
    email: "taxcommission@pbpnation.org",
    department: "Prairie Band Potawatomi Tax Commission"
  },
  children
}) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-white rounded-lg shadow-xl overflow-hidden">
        {/* Header */}
        <div className="bg-[#840028] py-6 px-6 text-center">
          <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-12 h-12 text-[#840028]" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-white mb-2">{title}</h1>
          <p className="text-white opacity-90">
            {subtitle}
          </p>
        </div>

        {/* Content */}
        <div className="p-8">
          <div className="text-center mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Download Your Report PDF
            </h2>
            <p className="text-gray-600 mb-6">
              We recommend downloading a PDF copy of your submitted report for your records. 
              This PDF contains all the information you submitted and can be used for future reference.
            </p>
            
            {/* Report Details */}
            {Object.keys(reportDetails).length > 0 && (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                <div className="flex items-center justify-center mb-2">
                  <svg className="w-6 h-6 text-blue-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="text-blue-800 font-semibold">Report Details</span>
                </div>
                <div className="text-sm text-blue-700 space-y-1">
                  {Object.entries(reportDetails).map(([key, value]) => (
                    <p key={key}><strong>{key}:</strong> {value}</p>
                  ))}
                </div>
              </div>
            )}

            {/* Custom content */}
            {children}
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={onDownload}
              className="flex items-center justify-center px-8 py-4 bg-[#840028] hover:bg-[#6a0020] text-white font-bold rounded-lg transition duration-200 shadow-lg hover:shadow-xl"
            >
              <svg className="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              {downloadButtonText}
            </button>

            <button
              onClick={() => navigate("/home")}
              className="flex items-center justify-center px-8 py-4 bg-gray-500 hover:bg-gray-600 text-white font-bold rounded-lg transition duration-200"
            >
              <svg className="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              {backButtonText}
            </button>
          </div>

          {/* Additional Information */}
          {showContactInfo && (
            <div className="mt-8 text-center text-sm text-gray-500">
              <p>Need help? Contact the {contactInfo.department}</p>
              <p>Phone: {contactInfo.phone} | Email: {contactInfo.email}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;